<template>
  <section
    v-if="variants.v1 === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="container">
      <div class="row d-block d-md-none mb-30" :class="{ 'order-1': vars.isReversedBool }">
        <div class="col-12">
          <div class="tw-relative" style="position: relative">
            <div
              v-if="vars.videoUrl"
              class="video-container"
              :style="{
                position: 'relative',
                zIndex: 1,
                borderRadius: 'var(--rounded)',
                overflow: 'hidden',
                width: '100%',
                height: '0',
                paddingBottom: videoAspectRatio,
              }"
            >
              <library-video-embed
                :video-url="String(vars.videoUrl)"
                :title="String(vars.videoTitle || 'Video')"
                :is-popup="false"
                :cover-photo="undefined"
                class="video-embed"
              />
            </div>

            <NuxtImg
              v-else-if="vars.photoImage"
              :src="String(vars.photoImage)"
              :style="{ borderRadius: 'var(--rounded)', overflow: 'hidden', position: 'relative', zIndex: 1 }"
            />

            <div
              :style="`position: absolute; top: 160px; bottom: 0; right: 0; width: 12px; background-color: var(--c-${vars.borderColor}); transform: translateX(6px); z-index: 0;`"
            ></div>
            <div
              :style="`position: absolute; left: 160px; right: -6px; bottom: 0; height: 12px; background-color: var(--c-${vars.borderColor}); transform: translateY(6px); z-index: 0;`"
            ></div>
          </div>
        </div>
      </div>

      <div class="row y-gap-30 justify-between items-center">
        <div class="col-xl-5" :class="{ 'order-md-1': vars.isReversedBool }">
          <div class="row y-gap-60 md:y-gap-30">
            <div v-html="vars.titleHtml"></div>
            <div v-for="(reason, index) in reasons" :key="String(reason.title)" class="col-12">
              <div class="iconCard -type-3">
                <div class="iconCard__icon">
                  <nuxt-img :src="String(reason.icon)" />
                </div>
                <div class="iconCard__content">
                  <h5 class="iconCard__title">{{ reason.title }}</h5>
                  <p class="iconCard__text">{{ reason.description }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 d-none d-md-block tw-relative" :class="{ 'order-md-0': vars.isReversedBool }">
          <div class="tw-relative" style="position: relative">
            <div
              v-if="vars.videoUrl"
              class="video-container"
              :style="{
                position: 'relative',
                zIndex: 1,
                borderRadius: 'var(--rounded)',
                overflow: 'hidden',
                width: '100%',
                height: '0',
                paddingBottom: videoAspectRatio,
              }"
            >
              <library-video-embed
                :video-url="String(vars.videoUrl)"
                :title="String(vars.videoTitle || 'Video')"
                :is-popup="false"
                :cover-photo="undefined"
                class="video-embed"
              />
            </div>

            <!-- Fallback to image if no video -->
            <NuxtImg
              v-else-if="vars.photoImage"
              :src="String(vars.photoImage)"
              :style="{ borderRadius: 'var(--rounded)', overflow: 'hidden', position: 'relative', zIndex: 1 }"
            />

            <!-- Gold border - right side -->
            <div
              :style="`position: absolute; top: 100px; bottom: 0; right: 0; width: 12px; background-color: var(--c-${vars.borderColor}); transform: translateX(6px); z-index: 0;`"
            ></div>

            <!-- Gold border - bottom side -->
            <div
              :style="`position: absolute; left: 100px; right: -6px; bottom: 0; height: 12px; background-color: var(--c-${vars.borderColor}); transform: translateY(6px); z-index: 0;`"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section
    v-if="variants.iphoneMockup === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div class="container">
      <div class="row d-block d-md-none mb-30" :class="{ 'order-1': vars.isReversedBool }">
        <div class="col-12">
          <div class="tw-relative" style="position: relative">
            <template v-if="isSmallThanDesktop && vars.videoUrl">
              <video
                :src="String(vars.videoUrl)"
                :poster="vars.photoImage ? String(vars.photoImage) : undefined"
                controls
                playsinline
                class="tw-w-full tw-h-auto"
                style="max-width: 100%; height: auto; border-radius: var(--rounded);"
              />
            </template>
            <template v-else>
              <Iphone15Mockup
                v-if="vars.videoUrl && vars.photoImage"
                :image="String(vars.photoImage)"
                :component="component"
              />
              <Iphone15Mockup v-else-if="vars.videoUrl" :video="String(vars.videoUrl)" :component="component" />
              <Iphone15Mockup v-else-if="vars.photoImage" :image="String(vars.photoImage)" :component="component" />
            </template>
          </div>
        </div>
      </div>

      <div class="row y-gap-30 justify-start items-center">
        <div class="col-xl-5" :class="{ 'order-md-1': vars.isReversedBool }">
          <div class="row y-gap-60 md:y-gap-30">
            <h2>{{ vars.titleText }}</h2>
            <div v-for="(reason, index) in reasons" :key="String(reason.title)" class="col-12">
              <div class="iconCard -type-3">
                <div class="iconCard__icon">
                  <nuxt-img :src="String(reason.icon)" :alt="String(reason.title) || 'Reason icon'"/>
                </div>
                <div class="iconCard__content">
                  <h5 class="iconCard__title">{{ reason.title }}</h5>
                  <p v-if="reason.description" class="iconCard__text">{{ reason.description }}</p>
                  <div v-else-if="reason.description_html" class="html" v-html="reason.description_html"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 d-none d-md-block tw-relative" :class="{ 'order-md-0': vars.isReversedBool }">
          <div class="tw-relative" style="position: relative">
            <template v-if="isSmallThanDesktop && vars.videoUrl">
              <video
                :src="String(vars.videoUrl)"
                :poster="vars.photoImage ? String(vars.photoImage) : undefined"
                controls
                playsinline
                class="tw-w-full tw-h-auto"
                style="max-width: 100%; height: auto; border-radius: var(--rounded);"
              />
            </template>
            <template v-else>
              <Iphone15Mockup
                v-if="vars.videoUrl"
                :video="String(vars.videoUrl)"
                :poster="vars.photoImage ? String(vars.photoImage) : undefined"
                :component="component"
              />
              <Iphone15Mockup v-else-if="vars.photoImage" :image="String(vars.photoImage)" :component="component" />
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section
    v-if="variants.v2 === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="container">
      <div class="row d-block d-md-none mb-30" :class="{ 'order-1': vars.isReversedBool }">
        <div class="col-12">
          <div class="tw-relative" style="position: relative">
            <div
              v-if="vars.videoUrl"
              class="video-container"
              :style="{
                position: 'relative',
                zIndex: 1,
                borderRadius: 'var(--rounded)',
                overflow: 'hidden',
                width: '100%',
                height: '0',
                paddingBottom: videoAspectRatio,
              }"
            >
              <library-video-embed
                :video-url="String(vars.videoUrl)"
                :title="String(vars.videoTitle || 'Video')"
                :is-popup="false"
                :cover-photo="undefined"
                class="video-embed"
              />
            </div>

            <NuxtImg
              v-else-if="vars.photoImage"
              :src="String(vars.photoImage)"
              :style="{ borderRadius: 'var(--rounded)', overflow: 'hidden', position: 'relative', zIndex: 1 }"
            />

            <div
              :style="`position: absolute; top: 160px; bottom: 0; right: 0; width: 12px; background-color: var(--c-${vars.borderColor}); transform: translateX(6px); z-index: 0;`"
            ></div>
            <div
              :style="`position: absolute; left: 160px; right: -6px; bottom: 0; height: 12px; background-color: var(--c-${vars.borderColor}); transform: translateY(6px); z-index: 0;`"
            ></div>
          </div>
        </div>
      </div>

      <div class="row y-gap-30 justify-between items-center">
        <div class="col-xl-5" :class="{ 'order-md-1': vars.isReversedBool }">
          <div class="row y-gap-60 md:y-gap-30">
            <div v-html="vars.titleHtml"></div>
            <div v-for="(reason, index) in reasons" :key="String(reason.title)" class="col-12">
              <div class="iconCard -type-3">
                <div class="iconCard__icon">
                  <nuxt-img :src="String(reason.icon)" />
                </div>
                <div class="iconCard__content">
                  <h5 class="iconCard__title">{{ reason.title }}</h5>
                  <p class="iconCard__text">{{ reason.description }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 d-none d-md-block tw-relative" :class="{ 'order-md-0': vars.isReversedBool }">
          <div class="tw-relative" style="position: relative">
            <div
              v-if="vars.videoUrl"
              class="video-container"
              :style="{
                position: 'relative',
                zIndex: 1,
                borderRadius: 'var(--rounded)',
                overflow: 'hidden',
                width: '100%',
                height: '0',
                paddingBottom: videoAspectRatio,
              }"
            >
              <library-video-embed
                :video-url="String(vars.videoUrl)"
                :title="String(vars.videoTitle || 'Video')"
                :is-popup="false"
                :cover-photo="undefined"
                class="video-embed"
              />
            </div>

            <!-- Fallback to image if no video -->
            <NuxtImg
              v-else-if="vars.photoImage"
              :src="String(vars.photoImage)"
              :style="{ borderRadius: 'var(--rounded)', overflow: 'hidden', position: 'relative', zIndex: 1 }"
            />

            <!-- Gold border - right side -->
            <div
              :style="`position: absolute; top: 0px; bottom: 100px; right: 0; width: 12px; background-color: var(--c-${vars.borderColor}); transform: translateX(6px); z-index: 0;`"
            ></div>

            <!-- Gold border - bottom side -->
            <div
              :style="`position: absolute; left: 100px; right: -6px; top: 0; height: 12px; background-color: var(--c-${vars.borderColor}); transform: translateY(-6px); z-index: 0;`"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import Iphone15Mockup from '~/components/common/Iphone15Mockup.vue';
import { useCoreStore } from '~/units/core/store';

export default defineNuxtComponent({
  name: 'WhyBox',

  mixins: [ComponentMixin],

  components: {
    Iphone15Mockup,
  },

  data() {
    return {
      variants: {
        v1: 'v1',
        iphoneMockup: 'iphoneMockup',
        v2: 'v2',
      },
    };
  },

  computed: {
    reasons() {
      return this.groupedVariables.reasons;
    },

    videoAspectRatio() {
      return this.vars.aspectRatio ? this.vars.aspectRatio : '56.25%';
    },

    isSmallThanDesktop() {
      const coreStore = useCoreStore();
      return coreStore.isSmallThanDesktop;
    },
  },

  methods: {},
});
</script>

<style scoped lang="css">
.iconCard.-type-3 .iconCard__icon {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 100px;
  height: 100px;
  font-size: 40px;
  border-radius: 100%;
  border: none !important;
  margin-right: 20px;
}

.video-container {
  position: relative;
  width: 100%;
}

.video-container .video-embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

:deep(.video-container iframe) {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (max-width: 575px) {
  .iconCard.-type-3 {
    flex-direction: row !important;
  }
}
</style>
